import { getCss, buildResponsiveStyles, mergeDeep, color as colorUtils } from '../../utils';
import { IconColors, TIconColors, IconSize, TIconSize, ICON_SIZE } from './icon-utils';

export const createStyles = (color: TIconColors, size: TIconSize): string => {
  const styles = getCss({
    '@global': {
      ':host': {
        display: 'inline-flex',
        color: 'inherit',
      },
      i: {
        display: 'flex',
        color: 'inherit',
        ...mergeDeep(
          buildResponsiveStyles(size, (sizeResponsive: IconSize) => ({
            width: `${ICON_SIZE[sizeResponsive]}px`,
            height: `${ICON_SIZE[sizeResponsive]}px`,
          }))
        ),
      },
      svg: {
        width: '100%',
        height: '100%',
        ...mergeDeep(
          buildResponsiveStyles(color, (colorResponsive: IconColors) => ({
            fill:
              colorResponsive === 'inherit'
                ? 'inherit'
                : colorResponsive === 'currentColor'
                ? 'currentColor'
                : colorUtils[colorResponsive],
          }))
        ),
      },
    },
  });

  return styles;
};
